<script>
import FundraiserPageCompact from '@/components/fundraiser-pages/public/fundraiser-page-compact.vue'

import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import paginationWithStoreMixin from '@/mixins/paginationWithStoreMixin.js'
export default {
  name: "FundraiserPagesFrontendList",
  components: { TwPaginator, TwButton, TwInput, TwLoadingSpinner, FundraiserPageCompact, XMarkIcon },
  mixins:[fetchDataMixin, paginationWithStoreMixin],
  props: {
    fundraiser: {
      type: Object,
      required:true
    },
    team: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      SearchQuery: null,
    }
  },
  computed: {
    itemsStoreModule() {
      return useFundraiserPagePublicStore(this.$options.name)
    },
    fundraiserPages() {
      return useFundraiserPagePublicStore(this.$options.name).getItemsByFundraiserId(this.fundraiser.id)
    },
    searchQuery() {
      const returnable = {}
      if(this.SearchQuery) {
        if (this.fundraiser && this.fundraiser.settings && this.fundraiser.settings.lock_title) {
          returnable.name = this.SearchQuery
        }
        else {
          returnable.title = this.SearchQuery
        }
      }
      return returnable
    }
  },
  watch: {
    page() {
      this.fetchFundraiserPages()
    },
    team() {
      this.$nextTick(() => {
        this.fetchFundraiserPages()
      })
    }
  },
  onUnmounted() {
    useFundraiserPagePublicStore(this.$options.name).clearItems()
  },
  mounted() {
    this.fetchFundraiserPages()
  },
  methods: {
    clearFilters() {
      this.SearchQuery = null
      this.page = 1
      this.fetchFundraiserPages()
    },
    async searchWithFundraiserPages() {
      if (this.SearchQuery) {
        this.page = 1 // Reset to first page on search
        await this.fetchFundraiserPages()
      }
    },
    async fetchFundraiserPages() {
      await this.fetchData(async () => {
        console.log('PerPage:', this.perPage)
        await useFundraiserPagePublicStore(this.$options.name).fetchItems({
          clear: true,
          fundraiser_id: this.fundraiser.id,
          page: this.page,
          per_page: this.perPage,
          ...(this.team ? { team_id: this.team.id } : {}),
          ...this.searchQuery
        })
      })
    }
  }
}
</script>

<template>
  <div>
    <div class="relative">
      <tw-input v-model="SearchQuery" placeholder="Search & hit enter" @keydown.enter="searchWithFundraiserPages" />
      <tw-button class="absolute py-1 px-2 right-2 top-[10px] btn-pill text-gray-600 text-xs" size="small" variant="light" @click="clearFilters">
        Clear
        <XMarkIcon class="h-4 w-4" />
      </tw-button>
    </div>
  </div>
  <div>
    <tw-loading-spinner v-if="Loading" />
    <div v-else-if="!Loading && fundraiserPages.length ===0" class="py-10">
      <p class="text-gray-500 text-center">
        No fundraiser pages found.
      </p>
      <p class="text-gray-500 text-center">
        You can create one by clicking the "Join this Cause" button on the campaign page.
      </p>
    </div>
    <div v-else class="grid sm:grid-cols-2 gap-5 md:gap-7 mt-5 md:mt-7">
      <fundraiser-page-compact v-for="fundraiserPage in fundraiserPages" :key="'fundraiser-page-compact-list-' + fundraiserPage.id + '-' + fundraiserPage.fundraiser_id" :fundraiser-page="fundraiserPage" />
    </div>
  </div>
  <div v-if="!Loading && total > perPage" class="flex justify-center mt-10">
    <tw-paginator v-model="page" class="justify-self-center" :per-page="perPage" :total="total" />
  </div>
</template>

<style scoped>

</style>
